import { heroFeature, heroSide } from '@/mocks/blackinfo';

export default function HeroLead() {
  return (
    <section className="mx-auto max-w-[1280px] px-4 md:px-6">
      <div className="mt-5 grid grid-cols-1 gap-5 lg:grid-cols-3">
        {/* 头号现场大卡 */}
        <a
          href="#timeline"
          className="group relative block overflow-hidden rounded-lg lg:col-span-2"
        >
          <div className="relative h-[340px] w-full md:h-[520px]">
            <img
              src={heroFeature.cover}
              alt={heroFeature.title}
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/25 to-black/10" />
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
              <div className="flex flex-wrap items-center gap-2">
                <span className="rounded bg-red-600 px-2 py-0.5 text-xs font-bold text-white">{heroFeature.tag}</span>
                <span className="rounded-full border border-white/30 bg-white/10 px-2.5 py-0.5 text-xs font-medium text-white backdrop-blur">
                  {heroFeature.status}
                </span>
              </div>
              <h2 className="mt-3 max-w-2xl font-display text-xl font-bold leading-snug text-white md:text-3xl">
                {heroFeature.title}
              </h2>
              <p className="mt-2 hidden max-w-2xl text-sm leading-relaxed text-white/80 md:line-clamp-2">
                {heroFeature.summary}
              </p>
              <div className="mt-4 flex flex-wrap items-center gap-4 text-xs text-white/75">
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-time-line" /> {heroFeature.time}
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-fire-fill text-red-400" /> {heroFeature.read}
                </span>
                <span className="inline-flex items-center gap-1 text-white underline-offset-4 group-hover:underline">
                  查看完整脉络 <i className="ri-arrow-right-line" />
                </span>
              </div>
            </div>
          </div>
        </a>

        {/* 右侧抢先看 */}
        <div className="flex flex-col gap-5">
          {heroSide.map((s) => (
            <a
              key={s.id}
              href="#today"
              className="group flex-1 overflow-hidden rounded-lg border border-stone-200 bg-white"
            >
              <div className="relative h-40 w-full sm:h-44 md:h-48">
                <img src={s.cover} alt={s.title} className="h-full w-full object-cover" />
              </div>
              <div className="flex flex-1 flex-col p-4">
                <div className="flex items-center gap-2">
                  <span className="rounded bg-stone-100 px-2 py-0.5 text-xs font-medium text-stone-700">{s.tag}</span>
                  <span className="text-[11px] text-stone-400">{s.status}</span>
                </div>
                <h3 className="mt-2 font-display text-base font-bold leading-snug text-stone-900 group-hover:text-red-700 md:text-lg">
                  {s.title}
                </h3>
                <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-stone-500 md:text-sm">{s.summary}</p>
                <div className="mt-auto flex items-center justify-between pt-3 text-xs text-stone-400">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line" /> {s.time}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-fire-line text-red-400" /> {s.heat}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}